import {
    Button,
    Field,
    Input,
    Loading,
    Modal,
    ModalFooter,
    ModalHeader,
    onChange,
    validate,
    ValidationErrors,
} from "modules/common";
import React, { useEffect, useState } from "react";
import { NotificationTemplate } from "services/communication";
import { useCreateOrUpdateNotificationTemplate } from "../hooks";

const ERROR_MESSAGES: { [P in keyof NotificationTemplate]?: string } = {
    name: "Naziv je obavezan",
};

interface Props {
    isActive: boolean;
    toggleModal: () => void;
    templateData: Partial<NotificationTemplate>;
    isLoading?: boolean;
}

export const SaveNotificationAsTemplateConfirmationModal: React.FC<Props> = ({
    isActive,
    toggleModal,
    templateData,
    isLoading = false,
}) => {
    const [errors, setErrors] = useState<ValidationErrors<NotificationTemplate>>({});
    const [notificationTemplate, setNotificationTemplate] = useState<Partial<NotificationTemplate>>(
        {}
    );

    useEffect(() => {
        if (isActive) setNotificationTemplate(templateData);
    }, [isActive]);

    const createNotificationTemplate = useCreateOrUpdateNotificationTemplate();

    const onSubmit = () => {
        const errors = validate(notificationTemplate, ERROR_MESSAGES);
        if (notificationTemplate.name && notificationTemplate.name.length > 150)
            errors.subject = "Naziv predloška ne smije sadržavati više od 150 znakova";
        setErrors(errors);

        if (Object.keys(errors).length !== 0) return;

        createNotificationTemplate
            .mutateAsync(notificationTemplate as NotificationTemplate)
            .then(_ => onClose());
    };

    const onClose = () => {
        setErrors({});
        setNotificationTemplate({});
        toggleModal();
    };

    return (
        <Modal
            isActive={isActive}
            onClose={onClose}
            modalHeader={<ModalHeader onClose={onClose} title="Spremanje predloška" />}
            modalFooter={
                <ModalFooter>
                    <div className="f-r even g-24">
                        <Button
                            type="button"
                            size="small"
                            variant="primary-ghost"
                            width="standard"
                            onClick={onClose}
                        >
                            ODUSTANI
                        </Button>
                        <Button
                            type="button"
                            size="small"
                            variant="primary"
                            width="standard"
                            onClick={onSubmit}
                        >
                            SPREMI
                        </Button>
                    </div>
                </ModalFooter>
            }
        >
            {isLoading ? (
                <Loading />
            ) : (
                <div className="communication-template-modal f-c g-24">
                    <div>
                        <Field errorMessage={errors.name} required name="UNESITE NAZIV PREDLOŠKA">
                            <Input
                                value={notificationTemplate.name}
                                isValid={!errors.name}
                                onChange={e =>
                                    onChange(
                                        { name: e.target.value },
                                        setNotificationTemplate,
                                        setErrors
                                    )
                                }
                                id="name"
                                name="name"
                                size="large"
                                type="text"
                                placeholder="Kreni tipkati..."
                            />
                        </Field>
                    </div>
                </div>
            )}
        </Modal>
    );
};
